var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgCaretaker = function SvgCaretaker(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494949",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.007 16.202c-.621.44-1.007 1.268-1.007 2.175 0 1.078.546 2.034 1.36 2.372 1.166 5.292 5.043 9.164 9.371 9.164 4.29 0 7.882-3.816 8.947-9.181.795-.352 1.322-1.295 1.322-2.355 0-.893-.378-1.631-1.006-2.014v-4.084a.5.5 0 1 0-1 0v4.394a.5.5 0 0 0 .326.469c.407.151.68.595.68 1.235 0 .768-.398 1.385-.864 1.485a.5.5 0 0 0-.387.4c-.913 5.086-4.197 8.65-8.018 8.65-3.88 0-7.452-3.64-8.451-8.653a.5.5 0 0 0-.398-.393c-.474-.089-.882-.71-.882-1.49 0-.675.31-1.246.717-1.435a.5.5 0 0 0 .29-.454v-4.764a.5.5 0 1 0-1 0v4.48Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.19 14.058a15.302 15.302 0 0 0 .794.563c.626.415 1.335.83 2.113 1.216 3.603 1.79 7.34 2.392 10.857 1.075 1.56-.585 3.023-1.54 4.365-2.893a.5.5 0 0 0-.71-.705c-1.242 1.253-2.582 2.128-4.005 2.661-3.214 1.204-6.684.645-10.062-1.034a18.87 18.87 0 0 1-2.006-1.153c-.354-.234-.6-.414-.725-.513a.5.5 0 1 0-.622.783ZM28.5 30.507l.026-1.739a.5.5 0 0 0-1-.015l-.026 1.74a.5.5 0 0 0 1 .014ZM21.5 30.5v-2a.5.5 0 1 0-1 0v2a.5.5 0 1 0 1 0ZM37.5 40.5v3a.5.5 0 1 0 1 0v-3a.5.5 0 1 0-1 0ZM10.5 40.5v3a.5.5 0 1 0 1 0v-3a.5.5 0 1 0-1 0Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.585 31.489a8.53 8.53 0 0 0 2.915.5.5.5 0 0 0 0-1 7.535 7.535 0 0 1-2.574-.44c-.449-.163-.757-.322-.907-.42a.5.5 0 0 0-.534-.008l-3.037 1.856-1.979.034c-.449-.01-1.044.02-1.747.119a11.635 11.635 0 0 0-3.183.904c-3.032 1.376-4.909 3.99-5.02 8.074L5.5 43.532a.5.5 0 0 0 1 .008l.019-2.415c.1-3.677 1.738-5.957 4.433-7.18a10.65 10.65 0 0 1 2.91-.825 10.069 10.069 0 0 1 1.565-.11c.019 0 .744-.011 2.174-.036a.5.5 0 0 0 .252-.073l2.9-1.772c.212.11.49.236.832.36Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.147 32.901a.5.5 0 0 0 .252.073l2.114.037.06-.001c.377-.008.919.019 1.566.11 1 .141 1.989.407 2.909.824 2.695 1.224 4.333 3.504 4.434 7.19l.018 2.406a.5.5 0 1 0 1-.008l-.019-2.415c-.111-4.094-1.988-6.707-5.02-8.083a11.635 11.635 0 0 0-3.183-.904 11.04 11.04 0 0 0-1.726-.12c-.026 0-.692-.01-2-.033l-3.037-1.856a.5.5 0 0 0-.534.008c-.15.098-.458.257-.907.42-.759.274-1.623.44-2.574.44a.5.5 0 1 0 0 1 8.53 8.53 0 0 0 2.915-.5c.342-.124.62-.25.831-.36l2.9 1.772ZM16 13h17v-3a5 5 0 0 0-5-5h-7a5 5 0 0 0-5 5v3Zm5-9h7a6 6 0 0 1 6 6v4H15v-4a6 6 0 0 1 6-6Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 39v4.5a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.5-.5H13a.5.5 0 0 0-.5.5v5a.5.5 0 1 0 1 0V39h22Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 38-1 1v-1h1Zm-3 0v1l-1-1h1Zm2-5.451 1-.15V39h-4v-6l.989-.149c.007.049.011.098.011.149v5h2v-5.451ZM15 38v1l-1-1h1Zm3 0-1 1v-1h1Zm-3 0h2v-5.451l1-.15V39h-4v-6l.989-.149c.007.049.011.098.011.149v5ZM34 38h1l-1 1v-1Zm-2 1-1-1h1v1Zm2-1v-5c0-.037.002-.073.006-.11L35 33v6h-4v-6.44l1 .11V38h2Zm-2 1-1-1h1v1Zm2-1h1l-1 1v-1Zm0 0v-5c0-.037.002-.073.006-.11L35 33v6h-4v-6.44l1 .11V38h2Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 40.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 40.5,
    r: 1
  }))));
};

export { SvgCaretaker as ReactComponent };
export default "/_next/static/media/caretaker.ba642174.svg";